import {
  AssignedProduct,
  getExpiryTerm,
  getPurchasePriceFormatted,
} from 'app/core/api/product-assignment/api-product-assignment.types';
import { Product } from 'app/core/api/product/api-product.types';
import { NameValueListItems } from 'app/tools/general.types';
import { SafeMap, sentenceCase } from 'app/tools/utils';
import { countries } from 'countries-list';
import _ from 'lodash';

export const productDetailsList = [
  'ean',
  'elid',
  'asin',
  // description is the wide one, so needs to be at an index of a
  // multiple of three, in this case it is at index 3.
  'description',
  'model',
  'dimension',
  'weight',
  'size',
  'color',
] as const;

export const uppercaseTitles: typeof productDetailsList[number][] = [
  'ean',
  'elid',
  'asin',
];

const safeMapCountries = new SafeMap(countries);

export const getProductDetailsList = (
  product: Product
): NameValueListItems =>
  productDetailsList.map(key => {
    const name = uppercaseTitles.includes(key)
      ? _.upperCase(key)
      : _.capitalize(key);
    const value = product[key] || '-';

    return { id: name, name, value };
  });

export const assignedProductDetailsList = [
  'purchaseDate',
  'purchasePlace',
  'purchaseCountry',
  'purchasePrice',
  'expiryTerm',
  'serialNumber',
] as const;

export const getAssignedProductDetailsList = (
  assignedProduct: AssignedProduct,
  showReceipt: boolean
): NameValueListItems =>
  assignedProductDetailsList
    .map(key => {
      let value: string | 0 | undefined;

      if (key === 'expiryTerm') {
        const rawValue = getExpiryTerm(assignedProduct);
        value = rawValue && `${rawValue} months`;
      } else if (key === 'purchasePrice') {
        value = getPurchasePriceFormatted(assignedProduct);
      } else if (key === 'purchaseCountry') {
        value = safeMapCountries.get(
          assignedProduct.purchaseCountry
        )?.name;
      } else {
        value = assignedProduct[key];
      }

      return {
        id: key as string,
        name: sentenceCase(key),
        value: value || '-',
      };
    })
    .concat([
      {
        id: 'receipt',
        name: 'Receipt / invoice:',
        value: showReceipt ? '' : '-',
      },
    ]);
